export const analyticsProperties = {
  source: 'source',
  component: 'component',
} as const;